export default "__VITE_ASSET__84bc6a7a__"